import crypto from "crypto-js";
import { CRPTO_SECRET_KEY } from "../utils/constant.js";
import axios from "axios";
export const currencySeprator = (value) => {
  return new Intl.NumberFormat("en-NG").format(value);
};
export const getNumberWithoutComma = (input) => {
  return input
    .toLocaleString()
    .replace(/,/g, "")
    .replace(/[^0-9]/g, "");
};

// export async function encryptedValueCrypto(dataToEncrypt) {
//   const secretKey = CRPTO_SECRET_KEY;
//   var encryptedData = await crypto.AES.encrypt(
//     dataToEncrypt,
//     secretKey
//   ).toString();
//   return encryptedData;
// }

export async function encryptedValueCrypto(dataToEncrypt) {
  if (!dataToEncrypt) {
    console.error("Encryption failed: No data provided.");
    return null;
  }

  const secretKey = CRPTO_SECRET_KEY;

  try {
    const stringData =
      typeof dataToEncrypt === "string"
        ? dataToEncrypt
        : JSON.stringify(dataToEncrypt);
    const encryptedData = crypto.AES.encrypt(stringData, secretKey).toString();
    return encryptedData;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
}

export async function decryptedValueCrypto(encryptedData) {
  if (!encryptedData) {
    console.error("Decryption failed: No data provided.");
    return null;
  }

  const secretKey = CRPTO_SECRET_KEY;

  try {
    const bytes = crypto.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(crypto.enc.Utf8);
    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
}

export const formatVisitMessage = (visitDates) => {
  let message =
    "Inquiry Message to be sent to the properties\n\nVisit Schedule:\n";

  visitDates.forEach((visit) => {
    const visitDate = new Date(visit.date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    message += `- ${visitDate}:\n`;

    visit.visitTime.forEach((time) => {
      const fromTime = new Date(time.fromTime).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const toTime = new Date(time.toTime).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      message += `  * ${fromTime} - ${toTime}\n`;
    });
  });

  return message.trim();
};

export function generateMessage(propertyInfo, loginInfo) {
  const lines = [];

  // Introducere
  lines.push(
    `Hai, eu sunt ${loginInfo?.user?.fullname || "un potențial client"}.`
  );

  // Detalii spațiu birou
  let officeDetails = "Caut un spațiu de birou";
  const address = propertyInfo?.location?.address;
  if (address) officeDetails += ` în zona ${address}`;
  lines.push(`${officeDetails}.`);

  // Durata contractului
  const lease = propertyInfo?.leaseDuration?.answer;
  if (lease) lines.push(`Durata contractului: ${lease}.`);

  // Plan mutare
  const moveIn = propertyInfo?.movePlan?.answer;
  if (moveIn) lines.push(`Plan de mutare: ${moveIn}.`);

  // Buget
  // const budget = propertyInfo?.budgetPricing?.answer;
  // if (budget) lines.push(`Buget: ${budget}.`);

  // Parcare
  const parking = propertyInfo?.parking?.answer;
  if (parking) lines.push(`Locuri de parcare: ${parking}.`);

  // Tip birou
  const officeType = propertyInfo?.officeType?.answer;
  if (officeType && officeType !== "Nicio preferință") {
    lines.push(`Tip preferat de birou: ${officeType}.`);
  }

  // Locație preferată
  const preferredLocation = propertyInfo?.preferredLocation?.answer;
  if (preferredLocation && preferredLocation !== "Deschis la sugestii") {
    lines.push(`Locație preferată: ${preferredLocation}.`);
  }

  // Angajați per zonă
  const employees = propertyInfo?.employeesPerArea;
  if (employees && parseFloat(employees) > 0) {
    lines.push(`Număr angajați per zonă: ${employees}.`);
  }

  // Informații contact
  // lines.push("\nMă puteți contacta la:");
  // if (loginInfo?.user?.phone) lines.push(`Telefon: ${loginInfo.user.phone}`);
  // if (loginInfo?.user?.email) lines.push(`Email: ${loginInfo.user.email}`);

  // Final
  lines.push("\nAștept cu interes răspunsul dumneavoastră!");

  return lines.join("\n");
}
